import { gql } from 'apollo-angular';

import {
  SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT,
  SNK_PRICE_DESCRIPTOR_FRAGMENT
} from 'graphql/fragments/snk-price-descriptor';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';

export const QUOTE_PRICING_FRAGMENT = gql`
  fragment QuotePricingFragment on Quote {
    pricing {
      # Dealer conditions
      listPriceDiscount { ...SnkPriceDescriptorFragment }
      buyPriceSurcharge { ...SnkPriceDescriptorFragment }
      manufacturerAdditionalDiscount { ...SnkPriceDescriptorChangedFragment }
      manufacturerAlternativeDiscount { ...SnkPriceDescriptorChangedFragment }
      manufacturerPositionDiscount { ...SnkPriceDescriptorChangedFragment }

      # Manufacturer conditions
      baseDiscount { ...SnkPriceDescriptorFragment }
      additionalDiscount { ...SnkPriceDescriptorChangedFragment }
      alternativeDiscount { ...SnkPriceDescriptorChangedFragment }
      positionDiscount { ...SnkPriceDescriptorChangedFragment }

      # Offer level only
      tz { ...SnkPriceDescriptorFragment }
      totalListPrice { ...SnkPriceDescriptorFragment }
      totalBuyPrice { ...SnkPriceDescriptorFragment }
      buyDiscount { ...SnkPriceDescriptorFragment }
      totalNetBuyPrice { ...SnkPriceDescriptorFragment }
      buyVat { ...SnkPriceDescriptorFragment }
      buyVatCurrency { ...SnkPriceDescriptorFragment }
      totalGrossBuyPrice { ...SnkPriceDescriptorFragment }
      totalSellPrice { ...SnkPriceDescriptorFragment }
      sellDiscount { ...SnkPriceDescriptorFragment }
      totalNetSellPrice { ...SnkPriceDescriptorFragment }
      sellVat { ...SnkPriceDescriptorFragment }
      sellVatCurrency { ...SnkPriceDescriptorFragment }
      totalGrossSellPrice { ...SnkPriceDescriptorFragment }
      sellProfitMargin { ...SnkPriceDescriptorFragment }
      sellProfitMarginCurrency { ...SnkPriceDescriptorFragment }

      # Offer level only (calculated)
      averageListPriceDiscount { ...SnkPriceDescriptorFragment }
      averageSurcharge { ...SnkPriceDescriptorFragment }
    }
    ...QuotePricingStateFragment
  }
  ${SNK_PRICE_DESCRIPTOR_FRAGMENT}
  ${SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;
